'use client';

import type { ReactNode } from 'react';
import { Button } from '../../../components/button';

export type InventoryIntegrationsLinkProps = {
  onClick: () => void;
  children: ReactNode;
};

export function InventoryIntegrationsLink({
  onClick,
  children,
}: InventoryIntegrationsLinkProps) {
  return (
    <Button
      variant="link"
      size="sm"
      p={0}
      h="auto"
      minH={0}
      fontWeight="medium"
      textDecoration="underline"
      onClick={onClick}
    >
      {children}
    </Button>
  );
}
